@if (actions$ | async) {}
@if (fileSharingDetails$ | async; as sharingDetails) {
  <nz-page-header nzBackIcon nzTitle="Файлообмен" (nzBack)="goBack()">
    <nz-page-header-content>
      <nz-descriptions nzSize="small" [nzColumn]="3">
        <nz-descriptions-item nzTitle="Дата создания" [nzSpan]="1"
          >{{ sharingDetails.createdAt | date: "dd.MM.yy HH:mm" }}
        </nz-descriptions-item>
        @if (sharingDetails.title.length > 0) {
          <nz-descriptions-item nzTitle="Тема" [nzSpan]="1">
            {{ sharingDetails.title }}
          </nz-descriptions-item>
        }
        <nz-descriptions-item nzTitle="Пользователь" [nzSpan]="1">
          {{ sharingDetails.user }}
        </nz-descriptions-item>
      </nz-descriptions>
    </nz-page-header-content>
  </nz-page-header>

  <div class="table-wrapper">
    <nz-table
      #basicTable
      nzBordered
      [nzData]="sharingDetails.files"
      [nzShowPagination]="false"
      [nzFrontPagination]="false"
    >
      <thead>
        <tr>
          <th>Название</th>
          <th>Описание</th>
          <th>Размер файла</th>
          <th>Действия</th>
        </tr>
      </thead>
      <tbody>
        @for (data of basicTable.data; track $index) {
          <tr class="version-wrapper">
            <td class="version">
              {{ data.contentName }}
            </td>
            <td class="version">
              {{ data.description }}
            </td>
            <td class="version">
              {{ getByteSize(data.contentLength) }}
            </td>
            <td class="actions">
              <button
                nz-button
                nzShape="round"
                [nzLoading]="$index === activeFileIndex && isDownloadingFiles"
                (click)="
                  downloadFile($index, data.contentKey, data.contentName)
                "
              >
                <span nz-icon nzType="download"></span>
                Скачать
              </button>
              <nz-divider nzType="vertical"></nz-divider>
              <button
                nz-button
                nzDanger
                nzShape="round"
                (click)="deleteFile(data.contentKey)"
              >
                Удалить
              </button>
            </td>
          </tr>
        }
      </tbody>
    </nz-table>
  </div>
}
